import React from "react";
import type { TFunction } from "i18next";
import { ResourceEnum } from "src/constants/constants.ts";
import type { Module } from "src/system/module.types.ts";
import type { DeliveryMethodResource } from "@exonn/js-sdk";

export const module: Module<DeliveryMethodResource> = {
  id: ResourceEnum.DeliveryMethod,
  bigIcon: <span className={"icon-20-deliv_metd"} />,
  smallIcon: <span className={"icon-15-deliv_metd"} />,
  name: (t: TFunction) => t("moduleName.deliveryMethods"),

  tabs: {
    edit: {
      getTitle: (resource) => resource.title,
    },
  },
};
